import { LoadableLazy } from '@confluence/loadable';

export const ConditionalPublish = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConditionalPublish" */ './ConditionalPublish.tsx'))
			.ConditionalPublish,
});
